import React from 'react';
import IconType from './iconType';

const CircleInfo = React.forwardRef<SVGSVGElement, IconType>(
  ({ color = '#616161', height = 16, width = 16, ...rest }, ref) => {
    return (
      <svg
        {...rest}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
      >
        <g clipPath="url(#clip0_20998_62237)">
          <circle cx="8.0026" cy="7.99967" r="6.66667" stroke={color} strokeWidth="1.5" />
          <path d="M8 11.333V7.33301" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="0.666667" cy="0.666667" r="0.666667" transform="matrix(1 0 0 -1 7.33594 6)" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_20998_62237">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

CircleInfo.displayName = 'CircleInfo';

export default CircleInfo;
